import { api } from "@/lib/api";
import { qzPrintPdf } from "@/lib/qz";
import { toast } from "sonner";

async function fetchPdf(ids) {
  try {
    const r = await api.post("/advances/slips", { ids }, { responseType: "blob" });
    return r;
  } catch (e) {
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      try { e.response.data = JSON.parse(await blob.text()); } catch (_) { /* keep original */ }
    }
    throw e;
  }
}

const fileName = (r, fallback) => {
  const m = /filename="?([^"]+)"?/.exec(r.headers?.["content-disposition"] || "");
  return m ? m[1] : fallback;
};

export async function downloadSlips(ids) {
  const r = await fetchPdf(ids);
  const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName(r, "BSHPL_Advance_Slips.pdf");
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export async function printSlips(ids) {
  const r = await fetchPdf(ids);
  const blob = new Blob([r.data], { type: "application/pdf" });
  const printer = await qzPrintPdf(blob);
  if (printer) { toast.success(`Sent to ${printer} via QZ Tray`); return; }
  const url = URL.createObjectURL(blob);
  document.getElementById("slip-print-frame")?.remove();
  const f = document.createElement("iframe");
  f.id = "slip-print-frame";
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  f.src = url;
  f.onload = () => {
    setTimeout(() => {
      try { f.contentWindow.focus(); f.contentWindow.print(); } catch (e) { window.open(url, "_blank"); }
    }, 300);
  };
  document.body.appendChild(f);
}
